export default function DesignPackageCiqIcon({
  size = 12,
  className = "fill-black",
  opacity = "0.6"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.151 6.97256C16.7718 6.97256 17.0309 6.17501 16.5267 5.80738L8.85458 0.226576C8.74501 0.146303 8.61272 0.103027 8.4769 0.103027C8.34107 0.103027 8.20878 0.146303 8.09922 0.226576L0.42712 5.80738C-0.0771216 6.173 0.18203 6.97256 0.804798 6.97256H2.04832V14.486H0.601896C0.513503 14.486 0.441182 14.5583 0.441182 14.6467V15.6913C0.441182 15.7797 0.513503 15.852 0.601896 15.852H16.3519C16.4403 15.852 16.5126 15.7797 16.5126 15.6913V14.6467C16.5126 14.5583 16.4403 14.486 16.3519 14.486H14.9055V6.97256H16.151ZM8.4769 1.64287L13.9231 5.60448H3.03069L8.4769 1.64287ZM3.49475 6.97256H5.8452V14.486H3.49475V6.97256ZM7.29163 6.97256H9.64208V14.486H7.29163V6.97256ZM13.459 14.486H11.0885V6.97256H13.459V14.486Z"
        fill="current"
        fillOpacity={opacity}
      />
    </svg>
  );
}
